import { PaxCartPnrUpdate } from "@app/interfaces";
import { Passenger } from "./passenger.model";
import { Reservation } from '@app/models/reservation.model';
import { PAX_TYPE } from "@app/enums";
import { Infant } from "./infant.model";
import { GlobalsService } from '@app/services/globals.service';

export class InternationFlow {
  reservation: Reservation;
  global: GlobalsService;
  private mCRFFlow: any[] = [
    { mcrs: ['TRAVEL_DOCUMENT', 'TRAVEL_DOC', 'INFANT_TRAVEL_DOCUMENT', 'TRAVEL_DOCUMENT_INFANT', 'TRAVEL_DOC_INFANT'], view: '/pax/passport', order: 1 },
    { mcrs: ['USPERSON'], view: '/pax/usPerson/formUsPerson', order: 2 },
    { mcrs: ['PHONE', 'EMAIL'], view: '/pax/contactInformation', order: 3 },
    { mcrs: ['RESIDENCE_ADDRESS', 'RESIDENCE_COUNTRY', 'COUNTRY_OF_RESIDENCE'], view: '/pax/residence', order: 4 },
    { mcrs: ['DESTINATION_ADDRESS', 'DESTINATION_ADDRESS_USA'], view: '/pax/destinationAddress', order: 5 },
    { mcrs: ['EMERGENCY_CONTACT', 'EMERGENCY_CONTACT_USA'], view: '/pax/emergency-contact', order: 6 },
    { mcrs: ['VISA_REQUIRED', 'INFANT_VISA_REQUIRED','DESTINATION_ADDRESS_USA'], view: '/pax/visa', order: 7 },
    { mcrs: ['TIMATIC_STATUS_REQUIRED', 'INFANT_TIMATIC_STATUS_REQUIRED'], view: '/pax/timatic', order: 8 },
  ];
  private missingCheckinRequiredFields: string[];
  public stackViewsInternational: any[];

  constructor(missingCheckinRequiredFields: string[]) {
    this.missingCheckinRequiredFields = missingCheckinRequiredFields;

    this.generateFlow();
  }

  private generateFlow() {
    this.stackViewsInternational = [];
    let order = 1;
    for (const flow of this.mCRFFlow) {
      for (const mcr of flow.mcrs) {
        const existFlow = this.missingCheckinRequiredFields.find(y => y.includes(mcr));
        if (existFlow) {
          this.stackViewsInternational.push({ view: flow.view, order, active: order === 1 });
          order++;
          break;
        }
      }
    }
  }


  nextPage() {
    let nameNextPage = '';
    if (this.stackViewsInternational?.length > 0) {
      const currentPage = this.stackViewsInternational.find(x => x.active);
      const nextOrderPage = currentPage.order + 1
      currentPage.active = false;
      const nextPage = this.stackViewsInternational.find(x => x.order == nextOrderPage);
      if (nextPage) {
        nextPage.active = true;
        nameNextPage = nextPage.view;
      }
    }
    return nameNextPage
  }

  previousPage() {
    const currentPage = this.stackViewsInternational.find(x => x.active);
    const previousOrderPage = currentPage.order - 1
    currentPage.active = false;
    const previousPage = this.stackViewsInternational.find(x => x.order == previousOrderPage);
    if (previousPage) {
      previousPage.active = true;
      return previousPage.view;
    }
    return ''
  }


  getRequestCartPnrUpdate(passenger: Passenger, reservation: Reservation): PaxCartPnrUpdate {
    let id;
    if (passenger.paxType == PAX_TYPE.INFANT) {
      id = (passenger as Infant).adultAssociate.id;

    } else {
      id = passenger.id;
    }

    let postData: PaxCartPnrUpdate = {
      _meta: { class: "CartPNRUpdate" },
      legCode: reservation.flightSummary.legCode,
      travelerInfo: {
        meta: { class: "BookedTravelerUpdateCollection" },
        _collection: [
          {
            meta: { class: "BookedTravelerUpdate" },
            id: id,
            isSelectedToCheckin: passenger.checkinSelected,
            gender: passenger.gender,
            dateOfBirth: passenger.dateOfBirth,
            countryOfResidence: (passenger.countryOfResidence ? passenger.countryOfResidence : passenger.paxInfo?.passportDocument?.issuingCountryCode),
            email: (passenger.email ? passenger.email : passenger.paxInfo?.contactInformation?.email),
            bookingClasses: passenger.bookingClasses,
            nameRefNumber: passenger.nameRefNumber,
          }
        ]
      }
    }
    if (passenger.paxInfo?.destinationAddress) {
      postData.travelerInfo._collection[0].destinationAddress = {
        addressOne: passenger.paxInfo.destinationAddress.addressDestination,
        addressTwo: "",
        city: passenger.paxInfo.destinationAddress.cityDestination,
        state: passenger.paxInfo.destinationAddress.stateDestination,
        finalDestination: passenger.paxInfo.destinationAddress.arrivalDestination,
        isTransitFlight: passenger.paxInfo.destinationAddress.destinationCheck,
        country: "US",
      }
    }
    if (passenger.paxInfo?.contactEmergency) {
      if(!passenger.paxInfo?.contactEmergency?.contactEmergencCheck){
        postData.travelerInfo._collection[0].emergencyContact = {
          firstName: passenger.paxInfo?.contactEmergency.contactEmergencyName,
          lastName: "lastName",
          phone: {
            meta: { class: "Phone" },
            type: "mobile",
            country: passenger.paxInfo?.contactEmergency.contactEmergenCountryCode,
            number: passenger.paxInfo?.contactEmergency.contactEmergenPhone
          },
          relationship: passenger.paxInfo?.contactEmergency.contactEmergenRelationship,
          country: passenger.paxInfo?.contactEmergency.contactEmergenCountryCode
        }
        delete postData.travelerInfo._collection[0].declinedEmergencyContact;
      }
      else {
        postData.travelerInfo._collection[0].declinedEmergencyContact = true;
      }
    }

    if (passenger.paxInfo?.passportDocument && passenger.paxInfo?.passportDocument?.passportScanned) {
      postData.travelerInfo._collection[0].travelDocument = {
        _meta: { class: "TravelDocument" },
        documentNumber: passenger.paxInfo?.passportDocument.documentNumber,
        issuingCountry: passenger.paxInfo?.passportDocument.issuingCountryCode,
        expirationDate: passenger.paxInfo?.passportDocument.expirationDate,
        passportScanned: passenger.paxInfo?.passportDocument.passportScanned,
        nationality: passenger.paxInfo?.passportDocument.nationalityCode
      }
    }

    if (passenger.paxInfo?.contactInformation) {
      postData.travelerInfo._collection[0].phones = {
        _meta: { class: "PhoneCollection" },
        _collection: [
          {
            meta: { class: "Phone" },
            type: "mobile",
            country: `${passenger.paxInfo.contactInformation.phone.contact_info_phone_code.country}`,
            number: `${passenger.paxInfo?.contactInformation.phone.phone_no}`
          }
        ]
      }
    }

    const visaInfo = passenger.paxInfo?.visaInfoCaptureInt;
    if (visaInfo?.numberVisa) {
      postData.travelerInfo._collection[0].visaInfo = {
        _meta: { class: 'VisaInfo' },
        number: passenger.paxInfo.visaInfoCaptureInt.numberVisa,
        issueCity: passenger.paxInfo.visaInfoCaptureInt.issuingCity,
        issueDate: passenger.paxInfo.visaInfoCaptureInt.broadcastDate,
        applicableCountryCode: passenger.paxInfo.visaInfoCaptureInt.destinationCountryCode,
        birthPlace: passenger.paxInfo.passportDocument.issuingCountryCode,
        expirationDate: passenger.paxInfo.visaInfoCaptureInt.expirationDate
      }
    }

    if (passenger.paxInfo?.timaticInformation) {
      postData.travelerInfo._collection[0].timaticInfo = {
        _meta: {class: 'TimaticInfo'},
        documentType: 1,
        residencyCountry: passenger.paxInfo.timaticInformation.countryResidenceCode,
        returnDate: passenger.paxInfo.timaticInformation.stayDate,
        stayType: 'VACATION'
      }
      if (visaInfo?.visaEta) {
        postData.travelerInfo._collection[0].timaticInfo.eTA = true;
      }
    }

    if (passenger.paxInfo?.residenceInfo) {
      postData.travelerInfo._collection[0].countryOfResidence = passenger.paxInfo.residenceInfo.countryOfResidence
    }

    return postData;
  }

  deletemCRFFlow(list) {
    let order = 1;
    this.stackViewsInternational = [];
    for (const flow of this.mCRFFlow) {
      for (let mcr of list) {
        const existFlow = flow.find(y => y.order = mcr);
        if (existFlow) {
          this.stackViewsInternational.push({ view: flow.view, order, active: order == 1 ? true : false });
          order++;
          break;
        }
      }
    };

    this.mCRFFlow = this.stackViewsInternational
  }

}
